/**
 * Created by zzy on 2019/7/23.
 */
import { clearStore } from 'utils/storage'
import { getNameById } from 'utils/public'
import resizeHandlerMixin from '@/mixins/resize-handler' // 引入mixin文件
import { notificationHttpRequest } from 'api'
import {getOneMonthBeginAndEndDate} from '../../utils/date'

export default {
  name: 'app-header',
  data () {
    return {
      // 遮罩层
      loading: false,
      // 查询条件
      dates: [],
      eventQueryParams: {
        lastEventId: 0,
        regionId: 0,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        resourceSubType: 255,
        systemKind: 0, // 系统种类
        alarmStates: [],
        alarmLevels: [],
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        orderBy: 0, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      lastEventId: 0,
      hasNewEvent: false,
      timer: null,
      pollingCount: 0
    }
  },
  computed: {
    sideBarOpen () {
      return this.$store.getters.appSideBarOpen
    }
  },
  mixins: [
    resizeHandlerMixin
  ],
  mounted () {
    this.$nextTick(() => {
      // 同步配置和store状态
      if (this.$store.getters.appSideBarOpen !== this.$globalConfig.sideBarOpen) {
        this.toggleSideBar()
      }

      // 强制处理一次resize
      this.$_resizeHandler()
    })

    // 获取上次最大事件id
    this.lastEventId = this.$store.getters.appLastEventId
    // 查询未处理的历史告警事件数量
    this.getUnhandledHistoryAlarmEventCount()
    // 查询最大历史事件Id
    this.getLastHistoryEventId()
    // 启动后台定时查询实时事件
    this.timer = setInterval(() => {
      ++this.pollingCount
      if (this.loading) { // 检测上一次查询是否尚未结束
        return
      }
      if (this.lastEventId === 0) {
        // 查询最大历史事件Id
        this.getLastHistoryEventId()
      } else {
        // 默认间隔2秒查询一次实时事件列表
        this.getRealEventList()
      }
      // 默认间隔60秒查询未处理的历史告警事件数量
      if (this.pollingCount % 30 === 0) {
        if (this.hasNewEvent) {
          this.getUnhandledHistoryAlarmEventCount()
          this.hasNewEvent = false
        }
      }
    }, this.$globalConfig.realEventPollingInterval)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 注销登录
    logout() {
      this.$messagebox.confirm('是否确定注销登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http(this.$api.logout, {}).then(
          res => {
            if (res.code === 200) {
            }
            clearStore()
            this.$router.push({path: '/login'})
          }
        )
      }).catch(() => {
      })
    },
    // 展开/收起左侧菜单
    toggleSideBar() {
      let sideBarOpen = !this.$store.getters.appSideBarOpen
      this.$store.commit('app/SET_SIDEBAR_OPEN', sideBarOpen)
    },
    // 查询未处理的历史告警事件（等级大于事项）数量
    getUnhandledHistoryAlarmEventCount() {
      // 查询返回历史告警事件记录集合，获取最大告警事件id
      this.eventQueryParams.lastEventId = 0
      this.eventQueryParams.alarmStates = [1] // 只返回告警状态的事件记录
      this.eventQueryParams.alarmLevels = [1, 2, 3] // 普通告警、重要告警、紧急告警
      this.dates = getOneMonthBeginAndEndDate() // 返回近一个月内的未确认报警事件
      this.eventQueryParams.beginHappenDateTime = this.dates[0] / 1000
      this.eventQueryParams.handleStates = [0]
      this.eventQueryParams.orderBy = 0 // 增序
      this.eventQueryParams.pageSize = 1
      this.loading = true
      // console.log('query history alarm event list')
      notificationHttpRequest(this.$api.historyEventList, this.eventQueryParams).then(
        res => {
          if (res.code === 200) {
            this.$store.commit('app/SET_UNHANDLED_ALARM_EVENT_COUNT', res.page.totalRow)
            console.log('unhandled alarm event count: ' + this.$store.getters.appUnhandledAlarmEventCount)
          }
          this.loading = false
        }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询最大历史事件Id
    getLastHistoryEventId() {
      // 查询返回历史事件记录集合，获取最大事件id
      this.eventQueryParams.lastEventId = this.lastEventId
      this.eventQueryParams.alarmStates = []
      this.eventQueryParams.alarmLevels = []
      this.eventQueryParams.handleStates = []
      this.eventQueryParams.orderBy = 1 // 减序
      this.eventQueryParams.pageSize = 1
      this.loading = true
      // console.log('query history event list')
      notificationHttpRequest(this.$api.historyEventList, this.eventQueryParams).then(
        res => {
          if (res.code === 200) {
            if (res.data.length > 0) {
              if (res.data[0].id > this.lastEventId) { // 更新最大事件id
                this.lastEventId = res.data[0].id
              }
              if (this.lastEventId > this.$store.getters.appLastEventId) { // 更新最大事件id
                this.$store.commit('app/SET_LAST_EVENT_ID', this.lastEventId)
              }
              console.log('lastEventId: ' + this.$store.getters.appLastEventId)
            }
          }
          this.loading = false
        }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询实时事件列表
    getRealEventList() {
      this.loading = true
      this.eventQueryParams.lastEventId = this.lastEventId
      this.eventQueryParams.alarmStates = []
      this.eventQueryParams.alarmLevels = []
      this.eventQueryParams.handleStates = []
      this.eventQueryParams.orderBy = 0 // 增序
      this.eventQueryParams.pageSize = 15
      // console.log('query real event list')
      notificationHttpRequest(this.$api.realEventList, this.eventQueryParams).then(
        res => {
          if (res.code === 200 && res.data.length > 0) {
            res.data.forEach(item => { // 更新最大事件id
              if (item.id > this.lastEventId) {
                this.lastEventId = item.id
              }
            })
            this.hasNewEvent = true // 设置有新事件标识
            this.showNotifications(res.data) // 显示通知消息框
            this.$store.commit('app/APPEND_NEW_EVENTS', res.data)
            this.$store.commit('app/SET_LAST_EVENT_ID', this.lastEventId)
            console.log('total: ' + this.$store.getters.appNewEvents.length + ', lastId: ' + this.lastEventId)
          }
          this.loading = false
        }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 显示通知消息框
    async showNotifications(events) {
      if (!this.$globalConfig.noticationEnabled) { // 通知启用
        return
      }

      const h = this.$createElement
      for (let i = 0; i < events.length; i++) {
        let event = events[i]
        await this.$notify({
          title: '通知消息',
          message: h('div', {class: 'notificationMessage'}, [
            h('img', {class: 'messageImage', attrs: {src: '/static/img/alarm/alert.png'}}, ''),
            h('div', {class: 'messageContent'}, [
              h('p', {class: 'messageText'}, [
                h('span', {class: 'label'}, '区域名称：'),
                h('span', {class: 'value'}, getNameById(event.regionId, this.$globalData.regions))]
              ),
              h('p', {class: 'messageText'}, [
                h('span', {class: 'label'}, '对象名称：'),
                h('span', {class: 'value'}, event.resourceName)]
              ),
              h('p', {class: 'messageText'}, [
                h('span', {class: 'label'}, '运行状态：'),
                h('span', {class: 'value'}, event.workStateText.length === 0 ? '-' : event.workStateText)]
              ),
              h('p', {class: 'messageText'}, [
                h('span', {class: 'label'}, '告警等级：'),
                h('span', {class: 'value'}, getNameById(event.alarmLevel, this.$type.alarmLevels))]
              ),
              h('p', {class: 'messageText'}, [
                h('span', {class: 'label'}, '告警状态：'),
                h('span', {class: 'value'}, event.alarmStateText)]
              ),
              h('p', {class: 'messageText'}, [
                h('span', {class: 'label'}, '事件类型：'),
                h('span', {class: 'value'}, event.eventTypeText),
                h('span', {class: 'label'}, '-'),
                h('span', {class: 'value'}, event.eventSubTypeText)]
              ),
              h('p', {class: 'messageText'}, [
                h('span', {class: 'label'}, '触发时间：'),
                h('span', {class: 'value'}, new Date(event.happenTime * 1000).Format('yyyy-MM-dd hh:mm:ss'))]
              )
            ])
          ]),
          position: 'bottom-right',
          duration: 15000, // 停留时间（毫秒）
          offset: 0, // 垂直方向偏移像素
          dangerouslyUseHTMLString: true
        })
      }
    },
    handleNewEventsClick() {
      this.$router.push({path: '/home/alarm-center'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/appHeader/AppHeader.js